import { Provider } from '@angular/core';
import { ChatRepositoryPort } from '@domain/ports';
import { UserRepositoryPort } from '@domain/ports';
import { ChatRealtimePort } from '@domain/ports';
import { ImgUploadPort } from '@domain/ports';
import { AuthProviderPort } from '@domain/ports';
import { HttpChatRepository } from './repositories/http-chat.repository';
import { HttpUserRepository } from './repositories/http-user.repository';
import { WebSocketChatService } from './services/websocket-chat.service';
import { HttpImgUploadService } from './services/http-img-upload.service';
import { MsalAuthProvider } from './auth/msal-auth.provider';

export const infrastructureProviders: Provider[] = [
  { provide: AuthProviderPort, useExisting: MsalAuthProvider },
  { provide: ChatRepositoryPort, useExisting: HttpChatRepository },
  { provide: UserRepositoryPort, useExisting: HttpUserRepository },
  { provide: ChatRealtimePort, useExisting: WebSocketChatService },
  { provide: ImgUploadPort, useExisting: HttpImgUploadService }
];
